// This is how a normal module looks like. You can copy paste this
// for any new module you want to create. Then you can import it in
// main.js and call "init()" to execute the code.


const Preloader = ((($) => {
  let preloaderLogo;
  let preloaderBtnL;
  let preloaderBtnR;
  let preloader;
  let Project_1;
  let Project_2;
  let Project_3;
  let Header;
  let Contact;
  let Current;
  let Hash;
  function init() {
    preloader = $('.Preloader');
    preloaderLogo = $('.Preloader__logo');
    preloaderBtnL = $('.btn-l');
    preloaderBtnR = $('.btn-r');
    Project_1 = $('#antonie');
    Project_2 = $('#colise');
    Project_3 = $('#rimbud');
    Header = $('.Header');
    Contact = $('.Contact-section');
    Current = window.location.pathname;
    Hash = document.location.hash;
    if(Hash === '#intro') {
      $('body').addClass('hide-intro');
    }
    else{
      $('body').addClass('show-intro');
    }
    if(Current === '/') {

      $('.hide_preloader').on('click', function() {

        $(this);
        setTimeout(function() {
          $(this);
          preloaderLogo.addClass('animated fadeOut');
        }, 200);
        setTimeout(function() {
          $(this);
          preloaderBtnL.addClass('animated fadeOut');
        }, 400);
        setTimeout(function() {
          $(this);
          preloaderBtnR.addClass('animated fadeOut');
        }, 600);
        setTimeout(function() {
          $(this);
          preloader.addClass('animated fadeOutLeftBig');
        }, 1300);
        setTimeout(function() {
          $(this);
          Project_3.addClass('animated fadeInDown');
        }, 1800);
        setTimeout(function() {
          $(this);
          Project_2.addClass('animated fadeInDown');
        }, 2000);
        setTimeout(function() {
          $(this);
          Project_1.addClass('animated fadeInDown');
        }, 2200);
        setTimeout(function() {
          $(this);
          Project_3.find('.Project__title').addClass('animated fadeInLeft');
        }, 2400);
        setTimeout(function() {
          $(this);
          Project_2.find('.Project__title').addClass('animated fadeInLeft');
        }, 2800);
        setTimeout(function() {
          $(this);
          Project_1.find('.Project__title').addClass('animated fadeInLeft');
        }, 3000);
        setTimeout(function() {
          $(this);
          Header.addClass('animated fadeIn');
        }, 3300);
        setTimeout(function() {
          $(this);
          Contact.addClass('animated fadeIn');
        }, 3400);
      });
    }
    else {
      Header.addClass('show-it');
      Contact.addClass('show-it');
    }
  }

  return {
    init,
  };
}))(jQuery);

export default Preloader;



// WEBPACK FOOTER //
// ./src/static/js/modules/preloader.js